var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C6.34315 3 5 4.34315 5 6C5 6.39025 5.07451 6.76309 5.21009 7.10508C3.93647 7.45179 3 8.61653 3 10C3 11.0623 3.5521 11.9956 4.38499 12.5286C4.13986 12.9634 4 13.4653 4 14C4 14.5347 4.13986 15.0366 4.38499 15.4714C3.55209 16.0044 3 16.9377 3 18C3 19.6569 4.34315 21 6 21H10C11.0666 21 12.0032 20.4434 12.5351 19.6048C13.4338 20.4688 14.6549 21 16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C14.9366 11 13.9507 11.332 13.1404 11.8979C12.9822 11.7369 12.806 11.5936 12.615 11.4714C12.8601 11.0366 13 10.5347 13 10C13 9.60975 12.9255 9.23691 12.7899 8.89492C14.0635 8.54821 15 7.38347 15 6C15 4.34315 13.6569 3 12 3H8ZM11.7595 13.3495C11.5761 13.1356 11.3039 13 11 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H11C11.0341 15 11.0678 14.9983 11.101 14.995C11.2222 14.4014 11.4484 13.8462 11.7595 13.3495ZM11 10C11 9.44772 10.5523 9 10 9H6C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11H10C10.5523 11 11 10.5523 11 10ZM8 7H12C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5H8C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7ZM11 18C11 17.4477 10.5523 17 10 17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H10C10.5523 19 11 18.5523 11 18ZM13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z",
    fill: "#E87421"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.46895d2dafacbbcf916e77908ac92f30.svg";
export { ForwardRef as ReactComponent };